import { useStoreActions, useStoreState } from '~/store/hooks';
import { useApiRequest } from '~/hooks/api';
import AllocationTypes from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/constants/allocationTypes';
import {
  IUseGetEditClientAllocationsParams,
  IUseGetDuplicateAllocationResult,
} from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/EditClientAllocation/hooks/types';

const useGetDuplicateClientAllocationsForTeamAdmin = ({
  actTeamId,
  clientAllocationDate,
  enabled = true,
}: IUseGetEditClientAllocationsParams): IUseGetDuplicateAllocationResult => {
  const { clinic: userClinic } = useStoreState(state => state.user.current);
  const clientAllocations = useStoreState(state => state.clientAllocation.current) || [];

  const { onGetClientAllocation } = useStoreActions(actions => actions.clientAllocation);

  const { isLoading, refetch } = useApiRequest(
    async () => {
      const clinicId = String(userClinic.id);
      const allocationDate = `${clientAllocationDate}T00:00:00Z`;

      await onGetClientAllocation({
        clinicId,
        teamId: actTeamId,
        clientAllocationDate: allocationDate,
        allocationType: AllocationTypes.ALL,
      });
    },
    {
      enabled,
      dependencies: [actTeamId, clientAllocationDate, userClinic.id],
    },
  );

  return {
    isLoading,
    allocations: clientAllocations,
    refetch,
  };
};

export default useGetDuplicateClientAllocationsForTeamAdmin;
